import { ACTION_TYPES } from '../constants/marketplaceApi.const';
import { getAppEnablePayload } from '../utils';

const initialState = {
  app_list:[],
  selected:{},
  userProfileData: null,
  voiceInboxData: null,
  airtcallPhoneNumberList: [],
  voiceInboxAuthUserData: null,
};
/**
 * @param {Object} state Default empty state
 * @param {Object} action Action dispached from AC
 */
export const smIntegrationReducer = (state = initialState, action) => {
  //NOSONAR
  switch (action.type) {
    
    case ACTION_TYPES.UPDATE_INTEGRATION_LIST: {
      return { ...state, app_list: action.payload };
    }
    case ACTION_TYPES.UPDATE_SELECTED_APP_DATA: {
      return { ...state, selected: action.payload };
    }
    case ACTION_TYPES.DISPATCH_WIDGET_ENABLE: {
      return { ...state, ...getAppEnablePayload(state, action) };
    }
    case ACTION_TYPES.SET_USER_PROFILE_DATA: {
      return { ...state, userProfileData: action.payload };
    }
    case ACTION_TYPES.SET_AIRCALL_SOLUTION_ID: {
      return { ...state, aircallInstanceId: action.payload };
    }
    case ACTION_TYPES.SET_VOICE_INBOX_DATA: {
      return { ...state, voiceInboxData: action.payload };
    }
    case ACTION_TYPES.SET_AIRCALL_PHONE_NUMBER_LIST: {
      return { ...state, airtcallPhoneNumberList: action.payload };
    }
    case ACTION_TYPES.SET_VOICE_INBOX_AUTH_USER_DATA: {
      return { ...state, voiceInboxAuthUserData: action.payload };
    }
    case ACTION_TYPES.RESET_VOICE_INBOX_DATA: {
      return { ...state, voiceInboxData: null, airtcallPhoneNumberList: [], voiceInboxAuthUserData: null };
    }
    default:
      return state;
  }
};
